import request from '@/API/';
const statusKey = 'dW2ZMEQ8/UXxF7uco2pziiEjFe2eqxdUFFXTDIuYK7g=';

export default {
  getAll: () => {
    return request.get(`api/status?key=${statusKey}`);
  },
};
